"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitMs = exports.getTimeDiffFromNow = void 0;
var getTimeDiffFromNow = function (time) { return Date.now() - time; };
exports.getTimeDiffFromNow = getTimeDiffFromNow;
var waitMs = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
exports.waitMs = waitMs;
